var _mask, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstructorSpotLesson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 262,
    height: 193,
    viewBox: "0 0 262 193",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 262,
    height: 193
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.0512695,
    width: 262,
    height: 192.581,
    fill: "#777BE1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.5083 141.968C79.6089 141.968 78.6999 141.861 77.7929 141.644C73.826 140.694 70.596 137.821 68.9318 133.76L53.6919 96.5614C53.5164 96.133 53.6904 95.6292 54.0808 95.4358C54.4702 95.2434 54.9297 95.4341 55.1053 95.8632L70.3453 133.061C71.8057 136.625 74.6406 139.147 78.1228 139.981C81.543 140.798 85.005 139.827 87.6201 137.314C87.7629 137.177 87.9051 137.036 88.0484 136.892C88.3637 136.574 88.8535 136.599 89.1432 136.946C89.4322 137.293 89.4105 137.831 89.0948 138.148C88.9424 138.302 88.7911 138.45 88.6398 138.596C86.3459 140.801 83.482 141.968 80.5083 141.968Z",
    fill: "#91B3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.818 91.3057L161.665 91.5584L161.667 91.5589C161.823 91.6053 161.914 91.7814 161.872 91.9521C161.83 92.123 161.67 92.2238 161.514 92.1774H161.514L160.663 91.9227C160.508 91.8761 160.417 91.7003 160.459 91.5298C160.501 91.3593 160.661 91.2588 160.817 91.3052L160.818 91.3057Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.648 92.1261L164.5 92.3599L164.502 92.3604C164.659 92.4035 164.755 92.5785 164.715 92.751C164.676 92.9235 164.517 93.0286 164.36 92.9853H164.36L163.504 92.7495C163.347 92.7062 163.252 92.5316 163.292 92.3593C163.331 92.1869 163.49 92.0824 163.647 92.1256L163.648 92.1261Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.493 92.8822L167.349 93.096L167.351 93.0964C167.51 93.1361 167.609 93.3096 167.573 93.4839C167.537 93.6582 167.379 93.7674 167.221 93.7279L167.22 93.7277L166.361 93.512C166.202 93.4722 166.103 93.299 166.139 93.1249C166.175 92.9508 166.333 92.8421 166.492 92.8817L166.493 92.8822Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.351 93.5709L170.212 93.7636L170.214 93.7641C170.374 93.8 170.477 93.972 170.445 94.1479C170.412 94.324 170.255 94.4377 170.095 94.4018L170.095 94.4016L169.231 94.2069C169.071 94.1709 168.968 93.9991 169.001 93.8235C169.034 93.6477 169.19 93.5344 169.35 93.5704L169.351 93.5709Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.224 94.1876L173.088 94.3585L173.09 94.3588C173.251 94.3909 173.359 94.5609 173.33 94.7387C173.301 94.9165 173.146 95.0347 172.984 95.0026H172.984L172.116 94.83C171.954 94.7979 171.847 94.6279 171.876 94.4504C171.906 94.273 172.06 94.1551 172.222 94.1873L172.224 94.1876Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.107 94.7305L175.975 94.8767L175.977 94.8772C176.14 94.9046 176.253 95.0725 176.227 95.2519C176.202 95.4313 176.05 95.5545 175.886 95.527L175.886 95.5269L175.014 95.3789C174.851 95.3512 174.739 95.1835 174.764 95.0044C174.789 94.8253 174.942 94.7025 175.105 94.7301L175.107 94.7305Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.002 95.1863L178.873 95.3052L178.875 95.3055C179.04 95.328 179.157 95.493 179.136 95.674C179.116 95.8551 178.966 95.9835 178.801 95.9611H178.801L177.925 95.8404C177.761 95.8177 177.644 95.653 177.664 95.4721C177.685 95.2914 177.835 95.1633 178 95.1858L178.002 95.1863Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.908 95.5512L181.781 95.6429L181.784 95.6432C181.95 95.6607 182.071 95.8228 182.056 96.0053C182.04 96.1879 181.892 96.3217 181.726 96.3041H181.726L180.847 96.2109C180.682 96.1933 180.56 96.0313 180.576 95.849C180.592 95.6668 180.74 95.5334 180.905 95.551L180.908 95.5512Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.821 95.8256L184.697 95.8902L184.699 95.8903C184.867 95.9027 184.993 96.0617 184.982 96.2455C184.971 96.4294 184.826 96.5683 184.658 96.5562H184.658L183.778 96.4902C183.611 96.4777 183.484 96.3187 183.496 96.1352C183.507 95.9517 183.652 95.8131 183.819 95.8256H183.821Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.741 96.0084L187.618 96.0455L187.62 96.0457C187.789 96.0528 187.92 96.2087 187.913 96.3937C187.907 96.5787 187.765 96.7229 187.597 96.7158H187.596L186.715 96.6775C186.546 96.6701 186.416 96.5145 186.422 96.3297C186.429 96.145 186.57 96.0011 186.739 96.0084H186.741Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.664 96.1001L190.541 96.1095H190.544C190.713 96.1113 190.849 96.2636 190.848 96.4496C190.846 96.6357 190.707 96.785 190.538 96.7832H190.538L189.655 96.7727C189.486 96.7707 189.35 96.6185 189.352 96.4326C189.354 96.2468 189.492 96.0978 189.662 96.0998L189.664 96.1001Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.589 96.0993L193.466 96.0806H193.468C193.639 96.077 193.779 96.2254 193.782 96.4124C193.786 96.5994 193.651 96.7538 193.48 96.7574H193.48L192.598 96.7753C192.428 96.7788 192.287 96.6303 192.284 96.4437C192.281 96.257 192.416 96.1029 192.586 96.0995L192.589 96.0993Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.511 96.0026L196.387 95.9549L196.39 95.9548C196.56 95.9456 196.706 96.0901 196.714 96.2777C196.722 96.4653 196.591 96.625 196.42 96.6342H196.42L195.538 96.6811C195.367 96.6901 195.222 96.5456 195.214 96.3583C195.206 96.1708 195.338 96.0117 195.508 96.0026H195.511Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.429 95.8102L199.304 95.7331L199.307 95.7327C199.478 95.7176 199.628 95.8579 199.642 96.046C199.655 96.2343 199.528 96.3989 199.356 96.4142H199.356L198.476 96.4908C198.305 96.5056 198.155 96.3655 198.142 96.1776C198.128 95.9896 198.256 95.8252 198.427 95.8102H198.429Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.341 95.5179L202.212 95.4103L202.215 95.4098C202.387 95.3886 202.542 95.5243 202.561 95.7127C202.58 95.9012 202.457 96.0712 202.285 96.0924H202.285L201.407 96.1996C201.236 96.2207 201.082 96.085 201.063 95.8967C201.043 95.7085 201.167 95.5389 201.338 95.518L201.341 95.5179Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.242 95.1231L205.109 94.9839L205.113 94.9834C205.284 94.956 205.444 95.0865 205.469 95.2752C205.494 95.4638 205.375 95.6389 205.203 95.6665H205.203L204.329 95.8056C204.157 95.8329 203.998 95.7024 203.973 95.5139C203.949 95.3255 204.067 95.1507 204.239 95.1235L204.242 95.1231Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.128 94.6211L207.991 94.4495L207.994 94.4488C208.165 94.4146 208.33 94.5397 208.361 94.7282C208.392 94.9166 208.278 95.097 208.106 95.1312H208.106L207.237 95.3032C207.066 95.3371 206.902 95.2121 206.871 95.0239C206.84 94.8356 206.954 94.6555 207.125 94.6216L207.128 94.6211Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.997 94.0095L210.853 93.8037L210.856 93.8029C211.027 93.7618 211.196 93.8809 211.234 94.0688C211.271 94.2568 211.163 94.4424 210.992 94.4835H210.991L210.128 94.6899C209.957 94.7309 209.789 94.6116 209.751 94.424C209.714 94.2362 209.823 94.0509 209.993 94.0101L209.997 94.0095Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.843 93.2831L213.691 93.042L213.695 93.041C213.865 92.9927 214.039 93.1051 214.083 93.2923C214.127 93.4794 214.025 93.6703 213.854 93.7188L213.854 93.719L212.998 93.9612C212.828 94.0094 212.655 93.8969 212.611 93.7099C212.567 93.523 212.669 93.3324 212.839 93.2842L212.843 93.2831Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.66 92.4353L216.498 92.1571L216.502 92.156C216.671 92.0997 216.85 92.205 216.901 92.3909C216.952 92.5768 216.856 92.7731 216.687 92.8292L216.687 92.8293L215.841 93.1091C215.672 93.165 215.493 93.0597 215.442 92.8739C215.391 92.6883 215.487 92.4924 215.656 92.4365L215.66 92.4353Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.442 91.4637L219.269 91.1468L219.273 91.1453C219.441 91.081 219.624 91.1784 219.682 91.3625C219.741 91.5469 219.652 91.7483 219.485 91.8124L219.484 91.8126L218.649 92.1316C218.482 92.1956 218.299 92.0982 218.241 91.9142C218.182 91.7302 218.271 91.5291 218.438 91.4651L218.442 91.4637Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.335 120.075C119.335 120.075 117.851 115.783 116.117 116.176C114.384 116.569 112.488 118.032 112.488 118.032L109.703 122.169C109.703 122.169 117.52 125.553 120.269 123.614C120.269 123.614 128.254 125.13 138.337 123.312C136.877 119.926 136.007 116.537 135.496 113.906C130.389 117.082 124.889 119.454 119.335 120.075Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.629 88.9441C161.629 88.9441 150.197 104.763 135.496 113.906C136.007 116.537 136.877 119.926 138.336 123.312C145.963 121.937 154.789 118.656 162.272 111.365L161.629 88.9441Z",
    fill: "#1B3234"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.94551 96.2397L31.6396 158.944C32.7946 162.136 35.7905 164.041 38.8847 163.552L98.3959 158.724L76.9604 92.0445C76.3894 90.395 74.9346 89.3197 73.3286 89.3603C62.8947 89.6244 24.8928 90.6554 11.2982 91.9846C9.41085 92.1691 8.22782 94.313 8.94551 96.2397Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8792 160.706L14.2056 97.438C13.748 96.1611 14.5872 94.7736 15.8361 94.7427L71.8785 92.4058C73.3224 92.3456 74.6429 93.2952 75.1704 94.7732L95.6961 156.448L36.8792 160.706Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.588 96.2396L212.894 158.944C211.739 162.136 208.743 164.041 205.649 163.552L146.138 158.977L167.573 92.0442C168.144 90.3947 169.599 89.3194 171.205 89.3601C181.639 89.6242 219.641 90.6552 233.235 91.9844C235.123 92.169 236.306 94.3129 235.588 96.2396Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.654 160.706L230.328 97.438C230.785 96.1611 229.946 94.7736 228.697 94.7427L172.655 92.4058C171.211 92.3456 169.89 93.2952 169.363 94.7732L148.837 156.448L207.654 160.706Z",
    fill: "#FFB8B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9492 91.0371L76.659 111.979C78.6748 112.741 80.5941 113.334 82.4216 113.777C83.5648 109.733 86.0819 104.771 88.143 101.081C80.5701 98.1395 75.9492 91.0371 75.9492 91.0371Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.758 90.6799C103.37 103.002 94.9619 103.728 88.1433 101.08C86.0822 104.77 83.5651 109.732 82.4219 113.776C110.163 120.495 116.696 92.476 116.696 92.476L113.758 90.6799Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.865 89.3719C115.865 89.3719 117.061 87.9602 119.276 88.4038C121.491 88.8475 123.462 89.6929 124.842 88.4038C126.222 87.1148 126.707 88.8447 126.707 88.8447L122.575 92.2958L115.865 89.3719Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.393 91.7846C113.393 91.7846 114.213 88.0179 116.684 88.5342C119.155 89.0504 124.764 92.402 126.21 91.7846C127.656 91.1673 129.504 89.6894 130.453 90.2117L128.782 92.4935C128.782 92.4935 133.077 89.7715 133.816 91.444L126.67 95.8621C126.67 95.8621 116.215 94.7121 113.393 91.7846Z",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.988 160.056C39.988 160.056 36.4436 104.46 62.2832 87.1722C62.2832 87.1722 69.5072 81.9324 78.509 92.0798C87.5107 102.227 84.6118 112.769 77.0576 122.649C69.5033 132.529 61.809 150.178 63.6401 160.056H39.988Z",
    fill: "#FC635F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3057 72.0289C75.2988 72.6919 66.6943 86.1194 66.6943 86.1194C66.6943 86.1194 68.2388 89.4613 75.6121 92.1744L81.9767 77.7976L75.3057 72.0289Z",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9219 118.13C71.9219 118.13 88.2468 133.151 105.875 126.597C106.969 126.19 108.164 126.279 109.185 126.871L114.253 129.811C116.38 131.046 119.014 130.235 120.249 127.967C120.953 126.673 121.553 125.195 121.673 123.779L111.756 119.369L112.487 118.033C112.487 118.033 107.646 117.582 106.379 121.394C106.379 121.394 97.1563 125.609 81.604 106.814C81.604 106.814 74.5466 113.407 71.9219 118.13Z",
    fill: "url(#paint9_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.043 118.064C70.9734 118.064 70.9031 118.042 70.8411 117.996C63.9473 112.879 60.7043 104.619 60.6723 104.536C60.5945 104.334 60.6802 104.101 60.8637 104.016C61.0474 103.93 61.2595 104.024 61.3373 104.226C61.3686 104.307 64.534 112.357 71.2455 117.339C71.4109 117.461 71.4543 117.708 71.3427 117.89C71.2728 118.003 71.159 118.064 71.043 118.064Z",
    fill: "url(#paint10_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2821 106.65C81.1635 106.65 81.0474 106.586 80.9783 106.468C80.9576 106.433 78.8562 102.839 74.8551 94.9674C73.6366 92.5704 72.0375 91.0529 70.1016 90.4575C66.8915 89.4702 63.7949 91.3631 63.7639 91.3823C63.5906 91.4903 63.3703 91.4236 63.2718 91.2331C63.1733 91.0427 63.234 90.8007 63.407 90.6925C63.5436 90.6074 66.7865 88.6182 70.2897 89.6912C72.4205 90.3445 74.1687 91.9894 75.4857 94.5805C79.4737 102.426 81.5647 106.003 81.5853 106.038C81.6935 106.223 81.6451 106.468 81.4774 106.587C81.4171 106.63 81.3491 106.65 81.2821 106.65Z",
    fill: "url(#paint11_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0802 64.3344C82.0802 64.3344 85.1418 72.0613 85.3474 76.1171C85.5531 80.1728 86.3485 82.8043 82.0802 83.6211C77.8119 84.4377 74.2163 82.1017 72.2683 78.0618C72.2683 78.0618 69.2161 71.8367 69.9009 69.2874C70.5855 66.7381 82.0802 64.3344 82.0802 64.3344Z",
    fill: "url(#paint12_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7272 75.1573L73.9702 75.0396C74.2796 74.8898 74.4119 74.4852 74.2566 74.1554C73.6547 72.8777 72.4813 69.9498 73.997 69.2669C75.9506 68.3866 83.6886 66.6529 85.358 63.6364C86.9625 60.7371 85.5409 56.9948 83.4042 55.9303C83.2613 55.8591 83.0926 55.9157 83.0192 56.0681L82.8413 56.4383C82.7194 56.6917 82.3788 56.6532 82.3062 56.3779C82.2366 56.1137 81.9166 56.0624 81.784 56.2957C81.2707 57.1982 79.8853 58.6614 76.1802 59.4127C70.9145 60.4804 67.4332 62.8216 67.3465 66.8191C67.341 67.073 67.0951 67.2143 66.8977 67.0821C66.5088 66.8218 65.8868 66.6996 65.0552 67.4677C63.609 68.8036 64.2008 72.2691 67.3709 75.1198C67.5215 75.2552 67.5203 75.5135 67.3573 75.6303C66.7826 76.0412 65.9258 77.0193 68.1458 78.323C70.442 79.6716 72.1566 79.5609 72.8168 79.4412C72.981 79.4114 73.087 79.2366 73.0511 79.058L72.3464 75.5444C72.3064 75.3456 72.4443 75.1572 72.6296 75.1572H73.7272V75.1573Z",
    fill: "#0B0754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8595 75.8989C73.8595 75.8989 72.6916 70.963 70.6772 72.347C68.6629 73.7309 71.7224 77.8774 73.3419 78.0621L73.8595 75.8989Z",
    fill: "url(#paint13_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.185 126.871C109.185 126.871 113.333 131.329 114.134 130.68C114.418 130.449 115.138 129.611 115.834 128.677C116.326 128.018 116.377 127.087 115.956 126.371L114.977 124.713C114.045 123.132 112.049 122.8 110.755 124.037C110.103 124.661 109.511 125.564 109.185 126.871Z",
    fill: "url(#paint14_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.557 159.238C174.557 159.238 174.529 139.208 163.929 118.524C160.613 112.054 159.434 104.524 160.468 97.186L161.629 88.945C161.629 88.945 176.177 83.5365 192.302 88.7172C192.302 88.7172 214.662 108.993 199.718 160.852L174.557 159.238Z",
    fill: "#1B3234"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.24 77.7641L168.012 87.7207C168.25 88.3495 168.765 88.7978 169.376 88.9129C171.551 89.3227 176.811 89.9627 180.266 87.4671C180.677 87.1698 180.782 86.555 180.501 86.1108L173.532 75.1182L164.24 77.7641Z",
    fill: "url(#paint15_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.41 125.218C172.89 125.369 172.632 126.01 172.881 126.533L183.794 149.524C183.978 149.912 184.386 150.104 184.769 149.982L220.466 138.659C220.911 138.518 221.167 138.008 221.039 137.519L214.889 114.132C214.763 113.651 214.311 113.37 213.871 113.497L173.41 125.218Z",
    fill: "#BDD0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.713 122.517C175.201 122.651 174.911 123.245 175.093 123.787L183.829 149.858C183.987 150.332 184.453 150.591 184.895 150.451L220.484 139.161C220.927 139.021 221.195 138.528 221.098 138.033L216.166 112.94C216.062 112.413 215.584 112.081 215.106 112.207L175.713 122.517Z",
    fill: "#91B3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.812 119.885C178.188 119.989 177.777 120.655 177.919 121.331L183.852 149.475C183.992 150.14 184.612 150.54 185.208 150.351L220.259 139.232C220.822 139.053 221.154 138.415 221.008 137.791L215.618 114.818C215.479 114.226 214.955 113.846 214.405 113.938L178.812 119.885Z",
    fill: "url(#paint16_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.185 130.618C209.905 108.041 194.069 90.6799 194.069 90.6799L184.646 102.748C191.8 112.544 195.201 121.521 196.754 128.572C198.814 127.913 203.774 126.871 207.185 130.618Z",
    fill: "#1B3234"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.754 128.837C196.645 128.837 196.547 128.756 196.52 128.635C194.593 119.89 190.535 111.236 184.459 102.915C184.376 102.801 184.392 102.634 184.496 102.543C184.6 102.451 184.751 102.47 184.834 102.584C190.955 110.966 195.044 119.689 196.988 128.511C197.019 128.653 196.94 128.796 196.811 128.83C196.792 128.835 196.773 128.837 196.754 128.837Z",
    fill: "#3E3E63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.754 128.572C198.198 135.125 198.046 140.014 197.826 142.348C197.743 143.229 197.1 143.916 196.296 143.977C195.384 144.048 194.142 144.14 193.032 144.21C191.812 144.287 190.458 143.44 189.552 142.732C189.09 142.37 188.492 142.933 188.75 143.488C189.426 144.941 191.141 146.234 192.323 146.995C192.753 147.271 192.673 147.978 192.193 148.127L187.138 149.701C195.445 158.299 200.929 148.679 200.929 148.679C204.596 142.454 206.492 136.367 207.185 130.618C203.774 126.871 198.814 127.913 196.754 128.572Z",
    fill: "url(#paint17_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.007 63.1941C167.848 63.3579 161.321 77.4415 161.321 77.4415L168.719 81.3656L176.711 69.027C176.711 69.027 170.659 60.4511 168.007 63.1941Z",
    fill: "url(#paint18_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.349 70.5065L169.659 77.2645C169.603 77.3672 169.536 77.4597 169.456 77.5413C169.017 77.9906 167.514 79.297 166.352 77.5181C165.362 76.002 164.433 74.6236 163.437 74.0551C162.856 73.7231 162.14 73.9882 161.845 74.631C161.237 75.9549 160.06 78.6534 159.32 81.2125C159.134 81.8538 159.436 82.5425 160.003 82.7952C161.501 83.462 164.462 84.668 167.09 85.0665C167.521 85.1319 167.949 84.932 168.206 84.5452C169.336 82.8437 172.522 78.0891 173.609 76.899C174.62 75.7933 176.484 76.2101 177.324 76.4754C177.643 76.576 177.983 76.5275 178.267 76.3396C179.12 75.7755 180.607 74.3707 179.246 71.9925C178.908 71.4012 179.081 70.6137 179.612 70.2297C180.563 69.5419 181.596 68.2508 180.612 66.1601C179.616 64.0436 177.837 63.8535 176.626 64.0163C176.09 64.0883 175.546 63.7795 175.34 63.2309C175.249 62.9869 175.068 62.7789 174.731 62.7039C174.096 62.5625 173.68 61.9245 173.804 61.2261C174.018 60.0284 173.857 58.4725 172.116 57.4211C168.924 55.4928 166.128 58.6348 165.417 61.2871C164.706 63.9395 168.275 65.814 170.52 66.1268C172.169 66.3565 173.074 68.3341 173.437 69.3677C173.57 69.7428 173.537 70.1615 173.349 70.5065Z",
    fill: "#0B0754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.224 79.3817C172.224 79.3817 173.644 74.8184 175.461 74.986C177.278 75.1536 178.708 77.1422 176.456 79.3779C173.655 82.1588 172.224 79.3817 172.224 79.3817Z",
    fill: "url(#paint19_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.631 161.512C118.631 162.681 117.768 163.629 116.704 163.629H38.437C36.8201 163.629 35.5094 162.189 35.5094 160.412L34.2783 158.841L115.545 158.076C117.256 158.102 118.631 159.632 118.631 161.512Z",
    fill: "url(#paint20_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.902 161.512C125.902 162.681 126.764 163.629 127.828 163.629H206.096C207.713 163.629 209.023 162.189 209.023 160.412L210.254 158.841L128.988 158.076C127.277 158.102 125.902 159.632 125.902 161.512Z",
    fill: "url(#paint21_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 111.942,
    y1: 127.996,
    x2: 128.991,
    y2: 120.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 8.73342,
    y1: 126.494,
    x2: 98.3959,
    y2: 126.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 82.3591,
    y1: 144.831,
    x2: -21.1298,
    y2: 87.7292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 146.138,
    y1: 126.494,
    x2: 235.8,
    y2: 126.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 89.4529,
    y1: 90.8962,
    x2: 73.0154,
    y2: 106.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 76.3825,
    y1: 118.454,
    x2: 122.57,
    y2: 94.3395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 76.1147,
    y1: 117.942,
    x2: 122.303,
    y2: 93.8272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 77.1623,
    y1: 119.948,
    x2: 123.35,
    y2: 95.8336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 77.962,
    y1: 74.8659,
    x2: 69.4011,
    y2: 89.7416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 72.0156,
    y1: 102.824,
    x2: 105.68,
    y2: 123.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 60.6435,
    y1: 111.024,
    x2: 71.4046,
    y2: 111.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9605A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 63.2246,
    y1: 98.012,
    x2: 81.6431,
    y2: 98.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9605A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 72.2162,
    y1: 62.2873,
    x2: 85.0455,
    y2: 81.4378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 66.9465,
    y1: 65.8179,
    x2: 79.7757,
    y2: 84.9685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 111.791,
    y1: 127.665,
    x2: 128.84,
    y2: 119.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 171.872,
    y1: 79.2044,
    x2: 176.169,
    y2: 97.4558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA4A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 198.803,
    y1: 126.305,
    x2: 210.511,
    y2: 174.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 213.603,
    y1: 106.418,
    x2: 196.351,
    y2: 136.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 160.674,
    y1: 66.4196,
    x2: 172.653,
    y2: 73.4491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 171.998,
    y1: 76.1155,
    x2: 175.844,
    y2: 78.7392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 76.1923,
    y1: 145.963,
    x2: 76.9312,
    y2: 179.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 167.778,
    y1: 143.92,
    x2: 168.517,
    y2: 177.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstructorSpotLesson);
export default __webpack_public_path__ + "static/media/instructor_spot_lesson.0fa97a24ab595c5a1c96505f2a13705e.svg";
export { ForwardRef as ReactComponent };